import React from "react";
import { Route } from "react-router-dom";

export default function renderRoutes(routes) {
  return (
    <>
      {routes.map((el) => (
        <Route path={el.path} element={el.component} key={el.path} />
      ))}
    </>
  );
}
